/* src/app/service-distributor/service-distributor.component.scss */
body {
  margin-left: 250px;
  background-color: #FCFCFD;
  padding: 32px;
  overflow-y: auto;
}
.empty-state {
  text-align: center;
  padding-top: 60px;
  padding-bottom: 60px;
  color: #bbb;
}
.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffecd9;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #ff8c00;
  margin-right: 15px;
}
::ng-deep .p-card {
  background: #ffffff;
  color: #4b5563;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
}
::ng-deep .p-datatable-wrapper {
  border: 1px solid #eaeaea;
  border-radius: 10px;
  overflow: hidden;
}
::ng-deep .p-datatable-sm .p-paginator .p-paginator-pages .p-paginator-page {
  padding: 0.25em 0.5em;
}
::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  background: #ffffff;
  border-color: #FF8C00;
  color: #FF8C00;
}
.add-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  border-radius: 8px;
  padding: 10px 16px;
  cursor: pointer;
  border: none;
  transition: background-color 0.3s, color 0.3s;
  height: 40px;
}
.txt:hover {
  text-decoration: underline;
  cursor: pointer;
}
th,
td {
  padding: 12px 24px;
  text-align: left;
  font-size: 12px;
  color: #475467;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
}
.customer-info {
  display: flex;
  align-items: center;
}
.phone,
.make,
.location {
  color: #888;
}
.status {
  display: inline-flex;
  align-items: center;
  padding: 5px 10px;
  border-radius: 5px;
  color: #fff;
  font-weight: bold;
}
.status.active {
  background-color: #4caf50;
}
.paginator-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
.paginator-left {
  display: flex;
}
.paginator-right {
  font-size: 14px;
}
.paginator-left button {
  margin-right: 5px;
}
::ng-deep .p-paginator .p-paginator-current {
  margin: 0;
}
::ng-deep .p-paginator .p-paginator-prev,
.p-paginator .p-paginator-next {
  margin: 0 5px;
}
::ng-deep .p-paginator button {
  background-color: #f4f6f8;
  border: 1px solid #ccc;
  border-radius: 5px;
  padding: 5px 10px;
  cursor: pointer;
  color: #616161;
}
::ng-deep .p-paginator button:hover {
  background-color: #ddd;
}
.p-paginate {
  background-color: white;
  border: 1px solid #D0D5DD;
  border-radius: 8px;
  color: #344054;
  font-size: 14px;
  font-weight: 500;
  padding: 8px;
}
.footer {
  color: #344054;
  font-size: 14px;
  font-weight: 500;
}
::ng-deep .p-datatable.p-datatable-sm .p-datatable-tfoot > tr > td {
  padding: 12px 20px !important;
  background-color: white;
}
.tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}
.tag.inreview {
  background-color: #FFF1E0;
  color: #D47500;
}
.tag.inreview::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #D47500;
}
.tag.approved {
  background-color: #ECFDF3;
  color: #027A48;
}
.tag.approved::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #4caf50;
}
.tag.submitted {
  background-color: #EEF4FF;
  color: #3538CD;
}
.tag.submitted::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #3538CD;
}
.tag.rejected {
  background-color: #FFEAEB;
  color: #FF474D;
}
.tag.rejected::before {
  content: " ";
  display: inline-block;
  width: 8px;
  height: 8px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #FF474D;
}
::ng-deep .p-tabview .p-tabview-nav {
  background: transparent;
  border: none;
  border-bottom: 1px solid #E4E7EC !important;
}
::ng-deep .p-tabview .p-tabview-nav li .p-tabview-nav-link {
  border: none !important;
  background: transparent !important;
  color: #6B7280;
  padding: 0px 4px 16px 4px;
  font-weight: 600;
  margin-right: 20px;
  position: relative;
  font-size: 14px;
}
::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link {
  color: #D47500 !important;
  border: none !important;
  margin-bottom: 0px;
}
::ng-deep .p-tabview .p-tabview-nav li.p-highlight .p-tabview-nav-link::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2.8px;
  background: #D47500;
}
::ng-deep .p-tabview .p-tabview-panels {
  background: transparent;
  padding: 24px 0 0 0;
  border: none;
}
::ng-deep .p-tabview .p-tabview-nav-content {
  border: none !important;
}
::ng-deep .p-inputtext {
  border-radius: 8px;
}
::ng-deep .p-inputtext:focus {
  outline: none !important;
  border-color: orange !important;
  background-color: white !important;
}
::ng-deep .p-inputtext:hover {
  outline: none !important;
  border-color: orange !important;
  background-color: white !important;
}
::ng-deep .p-dropdown:focus {
  outline: none !important;
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
  background-color: white !important;
}
::ng-deep .p-dropdown:hover-visible {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
::ng-deep .p-dropdown:hover {
  outline: none !important;
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
  background-color: white !important;
}
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
  color: #4b5563;
  background: #FFF1E0;
}
::ng-deep .p-dropdown-panel .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled):hover {
  color: #4b5563;
  background: #FFF1E0;
}
::ng-deep input:-webkit-autofill {
  background-color: white !important;
  box-shadow: 0 0 0px 1000px #fff inset !important;
  -webkit-text-fill-color: black !important;
}
::ng-deep input:hover,
input:focus {
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
}
::ng-deep textarea:hover,
textarea:focus {
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF;
}
::ng-deep .p-dropdown.p-focus,
::ng-deep .p-dropdown.p-highlight,
::ng-deep .p-dropdown:focus-within {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
::ng-deep textarea.p-focus,
::ng-deep textarea.p-highlight,
::ng-deep textarea:focus-within {
  border-color: orange !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px #F4EBFF !important;
}
::ng-deep .col-2 {
  padding: 0px;
}
/*# sourceMappingURL=service-distributor.component-OO2WC3C5.css.map */
